export default "__VITE_ASSET__C0kiv3vQ__"